export function delay(time: number, data?: any) {
    return new Promise((resolve) => {
        setTimeout(() => resolve(data), time);
    });
}
